import {FormSection} from '@/components/commons/form-section/FormSection'
import {MedicalReportTextAreaSections} from '@/features/medical-reports/components/medical-report-text-area-sections/MedicalReportTextAreaSections'
import {startProjectRehabilitationToSection} from '@/features/medical-reports/utils'
import {PlannedAccessesAdditionalNotesField} from '@/features/planned-accesses/components/accesses-form/planned-accesses-additional-notes-field/PlannedAccessesAdditionalNotesField'
import {PlannedAccessesFieldsSchema} from '@/features/planned-accesses/formSchemas'
import {useTranslation} from '@/translations/i18n'
import {z} from 'zod'

const PlannedAccessesFormTextAreaSchema = PlannedAccessesFieldsSchema.pick({
    treatmentsPlan: true,
    objectives: true
})
type PlannedAccessesFormTextAreaSchema = z.infer<typeof PlannedAccessesFormTextAreaSchema>

export const PlannedAccessesFormTextAreaSections = () => {
    const {t} = useTranslation()

    return (
        <>
            <MedicalReportTextAreaSections
                sectionsMap={startProjectRehabilitationToSection}
                schema={PlannedAccessesFormTextAreaSchema}
                hasDividers
            />
            <FormSection title={t('medical_records:additional_notes')}>
                <PlannedAccessesAdditionalNotesField />
            </FormSection>
        </>
    )
}
